import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SystemBackupRestore from './pages/SystemBackupRestore';
import ApiConfigPage from './pages/ApiConfigPage';
import GeneralSettings from './pages/GeneralSettings';
import KaratDeductionSettings from './pages/KaratDeductionSettings';
import SilverRateSettings from './pages/SilverRateSettings';
import WebsiteDeployment from './pages/WebsiteDeployment';

const SystemRoutes = () => {
    return (
        <Routes>
            <Route path="backup-restore" element={<SystemBackupRestore />} />
            <Route path="general-settings" element={<GeneralSettings />} />
            <Route path="api-config" element={<ApiConfigPage />} />
            <Route path="karat-deductions" element={<KaratDeductionSettings />} />
            <Route path="silver-rates" element={<SilverRateSettings />} />
            <Route path="website-deployment" element={<WebsiteDeployment />} />
        </Routes>
    );
};

export default SystemRoutes;
